import { Observable } from "rxjs";
import { DataService } from "@bb-vendure/admin-ui/core";
import { Pipe, PipeTransform } from "@angular/core";
import { FetchCustomerFromOrderIdDocument } from "../generated-graphql/graphql";

@Pipe({
  standalone: true,
  name: "customerNameFromOrderId",
})
export default class CustomerNameFromOrderIdPipe implements PipeTransform {
  constructor(private dataService: DataService) {}

  transform(orderId: string): Observable<{
    name: string;
    cusId: string;
  }> {
    return this.dataService
      .query(FetchCustomerFromOrderIdDocument, {
        orderId: orderId,
      })
      .mapStream((data) => ({
        name:
          data.order?.customer?.firstName +
          " " +
          data.order?.customer?.lastName,
        cusId: data.order?.customer?.id || '',
      }));
  }
}
